import {Fragment, useEffect, useState} from "react";
import WelcomeToSession from "../Home/components/WelcomeToSession";
import LandingPageAPI from '~/api/landingPageApi';
import {ImageSkeleton} from '~/components';
import Skeleton from "react-loading-skeleton";

function TermsCondition(){
    const [termCondition, setTermCondition] = useState([]);
    const [itemDetails, setItemDetails] = useState([]);
    const [targetId, setTargetId] = useState(1);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        LandingPageAPI.getTermCondition(0)
            .then(res => {
                setTermCondition(res.data);
                handleOnclickItem(1);
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
            })
    }, [])

    const handleOnclickItem = (id) => {
        setTargetId(id);
        LandingPageAPI.getTermCondition(id)
            .then(res => {
                setItemDetails(res.data);
            })
            .catch(error => {
                console.error(error);
            })
    }

    return(
        <Fragment>
            <WelcomeToSession screen="Terms & Conditions"/>
            <div className="container-medium mt-6 lh-lg">
                <div className="row border-bottom mb-7 pb-3">
                    <div className="col-sm-7 col-12" style={{lineHeight: '1.7rem'}}>
                        <h1 className="fs-lg-4 fs-md-1 fs-lg-2 fs-xl-2 fs fw-black mb-4"><span
                            className="text-primary me-3"> BreakThrough Website Terms of Use</span></h1>
                        <p>These Terms of Service (“Terms”) govern your use of Breakthrough and the software, content, and
                            services (collectively, “Services”) offered through our website www.breakthrough.chat and its
                            subdomains (the “Website”), our mobile apps Breakthrough for Android and Breakthrough for iOS (the
                            “Apps”).</p>
                        <p>Please read these terms carefully before you start using the Services.</p>
                        <p>The terms “Breakthrough,” “us,” or “we” refer to Paideia Society, a software company that designed
                            and built Breakthrough, incorporated in Delaware, and operating in San Francisco, CA. The term
                            “device” refers to the device that is used to access the Services, including but not limited to
                            computers, smartphones, and tablets.</p>
                        <p>The term “you” refers to the user of the Services. When you sign up for any Services or otherwise use
                            or access them, you agree to be bound by these Terms and all applicable laws, rules, and
                            regulations. By using the Services, you indicate that you accept these Terms and agree to abide by
                            them. If you disagree with these Terms, please refrain from using the services.</p>
                        <p>Our contact email address is paideia@breakthrough.chat. All correspondence to Breakthrough, including
                            any queries you may have regarding</p>
                        <p>Please send your use of the Services or these Terms to this contact email address.</p>
                    </div>
                    <div className="col-sm-5 col-12 m-auto">
                        <ImageSkeleton className={""} id={49} heightLoading={200}/>
                    </div>
                </div>
                {
                    loading && (
                        <div className="mt-4 container-medium mb-5">
                            <Skeleton height={10} count={5} containerClassName={"w-100"}/>
                        </div>
                    )
                }
                {
                    !loading && (
                        <div className="row">
                            <div className="col-sm-5 col-12">
                                <h4 className="mb-3">BreakThrough Legal</h4>
                                <ul className="list-unstyled">
                                    {termCondition.map((term, index) => (
                                        <li key={index} className={`mb-3 cursor-pointer fs-8-1 fw-semibold ${targetId === term.Id ? "text-primary" : ""}`}
                                            onClick={() => {handleOnclickItem(term.Id)}}
                                        >
                                            {term.Title}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col-sm-7 col-12" style={{lineHeight: '1.7rem'}}>
                                {
                                    itemDetails.map((item, index) => (
                                        <div key={index}>
                                            <strong>{item.Title}</strong>
                                            <div
                                                className=""
                                                dangerouslySetInnerHTML={{ __html: item.Content }}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </Fragment>
    )
}

export default TermsCondition;